import PropTypes from 'prop-types';
import { toast } from 'sonner';
import { useTranslation } from 'react-i18next';
import Button from 'Components/Atoms/Button/Button';
import useCategories from 'Hooks/useCategories';
import SnackbarCard from './SnackbarCard';
import SnackbarLayout from './SnackbarLayout';
import SnackbarMedia from './SnackbarMedia';
import SnackbarContent from './SnackbarContent';
import SnackbarSmallTitle from './SnackbarSmallTitle';

export default function SnackbarUndo({ id, message, onUndo, tagIds = [], actionLabel, action }) {
    const { categories } = useCategories();
    const { t } = useTranslation('common');

    const tags = tagIds.map((tagId) => categories.find((category) => category.id === tagId)).filter(Boolean);

    const handleUndo = () => {
        toast.dismiss(id);
        onUndo?.();
    };

    const handleAction = () => {
        toast.dismiss(id);
        action?.();
    };

    return (
        <SnackbarCard>
            <SnackbarLayout>
                {tags.length > 0 && (
                    <SnackbarMedia>
                        <div className="flex -space-x-1.5">
                            {tags.slice(0, 3).map((tag) => (
                                <span
                                    key={tag.id}
                                    className="rounded-lg grid place-content-center text-xl w-9 h-9 ring-2 ring-white"
                                    style={{ backgroundColor: tag.bgColor }}
                                >
                                    {tag.icon}
                                </span>
                            ))}
                        </div>
                    </SnackbarMedia>
                )}
                <SnackbarContent>
                    <SnackbarSmallTitle>{message}</SnackbarSmallTitle>
                </SnackbarContent>
                <div className="shrink-0 flex flex-col items-end gap-1">
                    <Button size="extraSmall" onClick={handleUndo}>
                        {t('undo')}
                    </Button>
                    {action && actionLabel && (
                        <Button size="extraSmall" variant="ghost" className="px-2" onClick={handleAction}>
                            {actionLabel}
                        </Button>
                    )}
                </div>
            </SnackbarLayout>
        </SnackbarCard>
    );
}

SnackbarUndo.propTypes = {
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    message: PropTypes.node.isRequired,
    onUndo: PropTypes.func,
    tagIds: PropTypes.arrayOf(PropTypes.string),
    actionLabel: PropTypes.string,
    action: PropTypes.func,
};
